// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SellerReviews__selfBlocked":"gs_a bhc_ea bhc_uy bhc_tq bhc_vk bhc_vf"};